/**
 * La vue du fil, gardee sur le telephone.
 *
 * « Pour toi » ou « Récent », choisie en tete du fil quand la ville publie
 * assez pour que la question se pose. Elle est retenue d'une ouverture a
 * l'autre.
 *
 * Les suggestions n'ont plus d'interrupteur dans les reglages : elles sont
 * actives pour tout le monde. Passer sur « Récent » reste la maniere de
 * lire le fil dans l'ordre des dates.
 */

const VUE = 'sirocco.pourtoi.mode';

export type ModeDuFil = 'pourtoi' | 'recent';

export function modeDuFil(): ModeDuFil {
  try {
    return localStorage.getItem(VUE) === 'recent' ? 'recent' : 'pourtoi';
  } catch {
    return 'pourtoi';
  }
}

export function changerDeMode(mode: ModeDuFil): void {
  try {
    localStorage.setItem(VUE, mode);
  } catch {
    // La vue choisie vaudra pour cette session seulement.
  }
}
